import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

type Environment = 'development' | 'production';

interface EnvironmentContextType {
    environment: Environment | null;
    loading: boolean;
}

const EnvironmentContext = createContext<EnvironmentContextType>({
    environment: null,
    loading: true,
});

export const useEnvironment = () => useContext(EnvironmentContext);

export const EnvironmentProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [environment, setEnvironment] = useState<Environment | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchEnvironment = async () => {
            try {
                const response = await api.get<{ environment: Environment }>('/environment');
                setEnvironment(response.data.environment);
            } catch (error) {
                // Fallback to NODE_ENV if API is unavailable
                setEnvironment(process.env.NODE_ENV === 'development' ? 'development' : 'production');
            } finally {
                setLoading(false);
            }
        };

        fetchEnvironment();
    }, []);

    return (
        <EnvironmentContext.Provider value={{ environment, loading }}>
            {children}
        </EnvironmentContext.Provider>
    );
};




